import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import BaseViewer from './Base';
import omit from 'lodash/omit';
import mergeTheme from '../Themes/mergeTheme';
import customboxTheme from '../Themes/Viewer/custombox.scss';
class CustomBoxViewer extends React.Component {
    render() {
        const restProps = omit(this.props, [
            'theme'
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            className: 'da-editor-custombox'
        }, /*#__PURE__*/ React.createElement(BaseViewer, _object_spread({
            theme: this.theme,
            showMediaAlwaysSmall: false,
            fixedParagraph: false
        }, restProps)));
    }
    constructor(props){
        super(props);
        _define_property(this, "theme", void 0);
        this.theme = mergeTheme(customboxTheme, this.props.theme);
    }
}
export { CustomBoxViewer as default };

//# sourceMappingURL=CustomBox.js.map